import { HeroSection } from '../components/sections/HeroSection';
import { AboutSection } from '../components/sections/AboutSection';
import { SubsidiariesSection } from '../components/sections/SubsidiariesSection';
import { ValuesSection } from '../components/sections/ValuesSection';
import { ContactCTASection } from '../components/sections/ContactCTASection';

export default function Home() {
  return (
    <main data-testid="home-page">
      <HeroSection />
      <AboutSection />
      <SubsidiariesSection />
      <ValuesSection />
      <ContactCTASection />
    </main>
  );
}
